import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AddMakeModal from '../../containers/global-settings/AddMakeModal'
import EditMakeModal from './EditMakeModal'
import RemoveMakeModal from '../../containers/global-settings/RemoveMakeModal'
import SettingList from './SettingList'
import { IVehicleMake } from 'src/types/vehicle'
import BackToList from '../ui/BackToList'

interface IMakePaneProps extends RouteComponentProps {
  makes: IVehicleMake[]
}

export default class MakePane extends React.Component<IMakePaneProps> {
  public render() {
    const makes = []
    for (const index of Object.keys(this.props.makes)) {
      const make = this.props.makes[index]
      makes.push({
        label: make.name,
        id: make.id
      })
    }
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddMakeModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveMakeModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditMakeModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Make</div>
            <Link
              className='btn bg-green rounded font-white mr2 flex justify-center items-center'
              to='/global-settings/make/create'
            >
              <Plus className='svg-white mr1' />
              Add Make
            </Link>
          </div>
          <hr />
          <div>
            <p className='h5 bold pl2 font-black'>Make List</p>
            <div className='pl3 pr3 col-4'>
              <SettingList baseUrl={this.props.match.path} settings={makes} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/MakePane.tsx